/*
 * sniarti-contact-log.js — mirror contact form submissions to the shared log.
 * Shared cross-brand layer: copy verbatim across brands alongside
 * sniarti-contact.js and the CEC-494 markup in sections/contact.liquid.
 *
 * Shopify's contact form keeps no record of what customers send, and silently
 * drops anything its spam filter dislikes — no bounce, nothing in the admin,
 * and the customer still sees the success banner. This mirrors each submission
 * to a Google Sheet so there is an audit trail independent of the e-mail.
 *
 * It records that a submission LEFT THE BROWSER, not that support received it.
 * A row with no matching e-mail is precisely the signal we had no way to see.
 *
 * Deliberately fire-and-forget: sendBeacon hands the payload to the browser,
 * which delivers it during unload without delaying the real POST to /contact.
 * Nothing here can block, slow, or fail a customer's submission — every path
 * is wrapped, and a dead endpoint costs the customer nothing.
 */
(function () {
  // Apps Script web app /exec URL. Empty disables logging entirely.
  var ENDPOINT = 'https://script.google.com/macros/s/AKfycbz-LxGrijYZVCZQ6WTG4HmGq7QurQhOyBJfaOINab1miZi1iud-fk85K8gfe4I7kxxW8g/exec';

  // Not a secret — it ships in this file. It only stops drive-by posting to a
  // URL someone finds in a network log. See the header of Code.gs.
  var TOKEN = 'e0JsM74Oi_PjuT20TXXS9lu02eoGa1nj';

  // Field names as rendered by sections/contact.liquid. These are the same
  // hard-coded names the notification e-mail uses, so they are stable.
  var FIELDS = {
    name:         'contact[name]',
    email:        'contact[email]',
    inquiry_type: 'contact[お問い合わせ種別]',
    order_number: 'contact[注文番号]',
    product:      'contact[商品名・カラー・サイズ]',
    body:         'contact[body]'
  };

  if (!ENDPOINT || ENDPOINT.indexOf('__') === 0) return;

  function value(form, name) {
    var el = form.querySelector('[name="' + name + '"]');
    return el ? (el.value || '').trim() : '';
  }

  // Anything the merchant added as a section block, so the log does not
  // silently lose fields we did not anticipate.
  function extras(form) {
    var known = {}, out = {}, k;
    for (k in FIELDS) known[FIELDS[k]] = true;

    var els = form.querySelectorAll('input[name^="contact["], select[name^="contact["], textarea[name^="contact["]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (!el.name || known[el.name] || el.type === 'hidden') continue;
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) continue;
      var v = (el.value || '').trim();
      if (v) out[el.name] = v;
    }
    return out;
  }

  function id() {
    try {
      if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    } catch (ignored) {}
    return String(Date.now()) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function send(payload) {
    var json;
    try { json = JSON.stringify(payload); } catch (ignored) { return; }

    // text/plain keeps this a CORS-simple request. sendBeacon cannot perform a
    // preflight, so application/json would be rejected before it left.
    try {
      if (navigator.sendBeacon) {
        var blob = new Blob([json], { type: 'text/plain;charset=UTF-8' });
        if (navigator.sendBeacon(ENDPOINT, blob)) return;
      }
    } catch (ignored) {}

    // Older Safari, or a beacon the browser refused to queue.
    try {
      fetch(ENDPOINT, {
        method: 'POST',
        body: json,
        mode: 'no-cors',
        keepalive: true,
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' }
      });
    } catch (ignored) {}
  }

  function record(form, route) {
    try {
      send({
        token:         TOKEN,
        route:         route,
        shop:          (window.Shopify && Shopify.shop) || location.hostname,
        submitted_at:  new Date().toISOString(),
        submission_id: id(),
        page_url:      location.href,
        name:          value(form, FIELDS.name),
        email:         value(form, FIELDS.email),
        inquiry_type:  value(form, FIELDS.inquiry_type),
        order_number:  value(form, FIELDS.order_number),
        product:       value(form, FIELDS.product),
        body:          value(form, FIELDS.body),
        extra:         extras(form)
      });
    } catch (ignored) {}
  }

  function closest(el, sel) {
    if (el && el.closest) return el.closest(sel);
    while (el && el.nodeType === 1) {
      if (el.matches && el.matches(sel)) return el;
      el = el.parentNode;
    }
    return null;
  }

  // 'submit' fires only once the browser's own validation has passed, so a
  // blocked submission is never logged as if it had gone out. Delegated from
  // the document so a theme-editor re-render cannot drop the listener.
  document.addEventListener('submit', function (event) {
    var form = closest(event.target, '.contact-form');
    if (form) record(form, 'form');
  }, true);

  // The defect route never posts the form — CEC-494 sends those by e-mail so a
  // photo can be attached. Without this the per-type counts would be missing
  // defects entirely. It logs the click, not a sent e-mail.
  document.addEventListener('click', function (event) {
    var link = closest(event.target, '[data-contact-defect] a[href^="mailto:"]');
    if (!link) return;
    var form = closest(link, '.contact-form');
    if (form) record(form, 'defect_mailto');
  }, true);
})();
